module.exports = __webpack_public_path__ + "img/wechat.41c3dc43.png";